export default function isIOSMobileDevice() {
    return /iPad|iPhone|iPod/g.test(navigator.userAgent);
}
